const pageNameKey = "blueprintStateInfoBannerModalsButtonsWrapper";

export const blueprintStateInfoBannerModalsButtonsWrapperEn = {
  [pageNameKey]: {
    openFindBlueprintModal: "Open Find Blueprint Modal",
    openSaveBlueprintModal: "Open Save Blueprint Modal",
  },
};

export const blueprintStateInfoBannerModalsButtonsWrapperPtBr = {
  [pageNameKey]: {
    openFindBlueprintModal: "Abrir modal de localizar blueprint",
    openSaveBlueprintModal: "Abrir modal de salvar blueprint",
  },
};

export const blueprintStateInfoBannerModalsButtonsWrapperDe = {
  [pageNameKey]: {
    openFindBlueprintModal: "Modal Blueprint suchen öffnen",
    openSaveBlueprintModal: "Modal Blueprint speichern öffnen",
  },
};

export const blueprintStateInfoBannerModalsButtonsWrapperZhHans = {
  [pageNameKey]: {
    openFindBlueprintModal: "打开查找蓝图模态框",
    openSaveBlueprintModal: "打开保存蓝图模态框",
  },
};

export const blueprintStateInfoBannerModalsButtonsWrapperIt = {
  [pageNameKey]: {
    openFindBlueprintModal: "Cerca blueprint",
    openSaveBlueprintModal: "Salva blueprint",
  },
};

export const blueprintStateInfoBannerModalsButtonsWrapperEs = {
  [pageNameKey]: {
    openFindBlueprintModal: "Abrir modal de búsqueda de planos",
    openSaveBlueprintModal: "Abrir modal para guardar plano",
  },
};

export const blueprintStateInfoBannerModalsButtonsWrapperNl = {
  [pageNameKey]: {
    openFindBlueprintModal: "Modaal venster voor blueprint zoeken openen",
    openSaveBlueprintModal: "Modaal venster voor blueprint opslaan openen",
  },
};

export const blueprintStateInfoBannerModalsButtonsWrapperTr = {
  [pageNameKey]: {
    openFindBlueprintModal: "Blueprint Modelini Bul'u açın",
    openSaveBlueprintModal: "Blueprint Modal'ı Kaydet'i açın",
  },
};
